import React, { useState } from "react";
import { History } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

// Historial de visualizaciones del portal (sólo fecha/hora). Contador y primera visita se mantienen intactos.
export default function HistorialVistasPresupuesto({ presupuesto: p }) {
  const [open, setOpen] = useState(false);
  const eventos = p?.portal_historial_vistas || [];
  const total = p?.portal_visitas || 0;
  const sinDetalle = Math.max(total - eventos.length, 0);
  const lista = eventos.map((e, i) => ({ n: i + 1 + sinDetalle, at: e.at })).reverse();
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="historial-vistas-btn"
        title="Ver historial de visualizaciones"
        className="inline-flex items-center gap-1 text-[11px] text-cyan-300 hover:text-cyan-200 mt-1">
        <History className="w-3 h-3" /> Ver historial
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-zinc-950 border-zinc-800 text-zinc-100 max-w-md" data-testid="historial-vistas-dialog">
          <DialogHeader><DialogTitle className="text-base">Historial de visualizaciones · {p?.numero}</DialogTitle></DialogHeader>
          <div className="text-xs text-zinc-400" data-testid="historial-vistas-resumen">
            Visto <b className="text-zinc-100">{total}</b> {total === 1 ? "vez" : "veces"}
            {p?.portal_visto_at && <> · primera {fmt(p.portal_visto_at)}</>}
            {(p?.portal_ultima_visita_at || eventos.length > 0) && <> · última {fmt(p.portal_ultima_visita_at || eventos[eventos.length - 1]?.at)}</>}
          </div>
          {lista.length === 0 ? (
            <div className="text-sm text-zinc-500 italic" data-testid="historial-vistas-vacio">
              {total > 0 ? "Historial detallado no disponible para visualizaciones anteriores a la implantación." : "El cliente aún no ha abierto el presupuesto."}
            </div>
          ) : (
            <ol className="divide-y divide-zinc-800 max-h-[50vh] overflow-y-auto" data-testid="historial-vistas-lista">
              {lista.map((e) => (
                <li key={`${e.n}-${e.at}`} className="flex items-center justify-between py-1.5 text-sm" data-testid={`historial-vista-${e.n}`}>
                  <span className="text-zinc-400">{e.n}ª visualización</span>
                  <span className="font-mono text-zinc-100">{fmt(e.at)}</span>
                </li>
              ))}
            </ol>
          )}
          {sinDetalle > 0 && eventos.length > 0 && (
            <div className="text-[11px] text-zinc-500" data-testid="historial-vistas-nota">
              Historial detallado disponible desde {fmt(eventos[0].at)} · {sinDetalle} visualización{sinDetalle === 1 ? "" : "es"} anterior{sinDetalle === 1 ? "" : "es"} sin fecha registrada.
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
